import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faUser } from '@fortawesome/free-regular-svg-icons';
import styles from '../styles/components/partner.module.css';
import globalStyles from '../styles/global.module.css';

const PartnerSection = () => {
  return (
    <section className={styles.partnerSection}>
      <div className={styles.partnerContainer}>
        <h2 className={styles.sectionTitle}>
          We are open to cooperation
        </h2>
        <p className={styles.sectionSubtitle}>
          Our business hub constantly and actively growing and helping to transfer and create a business in Georgia and international business, including in other countries. If you have experience adapting business projects or you are an experienced consultant or just think that we can be useful to each other - write to us. We will definitely contact you.
        </p>
        <div className={styles.buttonContainer}>
          <a 
            href="https://docs.google.com/forms/d/1nFclNcpENZMT9bsmf9uTawc3NwFGKNDqhBgVsW0tWsk/viewform" 
            target="_blank" 
            rel="noopener noreferrer" 
            className={styles.partnerButton}
          >
            <span className={styles.buttonIcon}>
              <FontAwesomeIcon icon={faHandshake} />
            </span>
            <span>Became as partner</span>
          </a>
          <a
            href="mailto:hitech.business.hub@gmail.com"
            className={styles.partnerButton}
          >
            <span className={styles.buttonIcon}>
              <FontAwesomeIcon icon={faUser} />
            </span>
            <span>Join the team</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PartnerSection; 